import React, { useState, useEffect } from 'react';

import { Button, Modal, Form, Input, Message, Header } from 'semantic-ui-react';
import { Dropdown, Label, Grid, Icon, Loader}  from "semantic-ui-react";
import Config from 'Config';

const TOKEN = `dbadmintoken`;
const REACT_APP_BTM_SITE = "dailybreak.com"

// just so everyone doesn't need to worry about the implementation
export const getToken = () => {
    return localStorage.getItem(TOKEN);
}

const beaker2Login = (username, password) => {
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);

    const request = new Request(`${Config.WEBSITE_API_URL}admin/auth/login`, {
        method: 'POST',
        body: formData,
        // headers: new Headers({ 'x-btm-site': `${process.env.REACT_APP_BTM_SITE}` }),
        headers: new Headers({ 'x-btm-site': `${REACT_APP_BTM_SITE}` }),
        credentials: 'include',
    });
    
    return fetch(request)
        .then(response => {
            // 1. Check for standard HTTP error codes (4xx, 5xx)
            if (response.status < 200 || response.status >= 300) {
                // Read the response text/JSON for better error message if possible
                // Otherwise, throw the status text
                throw new Error(response.statusText || `Request failed with status: ${response.status}`);
            }

            // 2. Check for the token, even if status is 200 (Crucial for bad credentials)
            const token = response.headers.get('x-token');
            
            if (!token) {
                // If the token is missing, treat this as a logical authentication error.
                // The message below will be displayed in your error state.
                throw new Error('Invalid username or password.'); 
            }
            
            return token;
        });
}


export const Beaker2LoginButton = ({onTokenChange}) => {

    const [modalOpen, setModalOpen] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  // Check initial login state on load
  useEffect(() => {
    if (localStorage.getItem(TOKEN)) {
      setIsLoggedIn(true);
      onTokenChange(localStorage.getItem(TOKEN))
    }
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    setSuccessMessage('');

    beaker2Login(username, password)
      .then((token) => {
        localStorage.setItem(TOKEN, token);

        setIsLoggedIn(true);
        setSuccessMessage('Successfully logged in! Token stored locally.');
        onTokenChange(token);

        // Clear form inputs
        setUsername('');
        setPassword('');

        // Close the modal after a brief moment
        setTimeout(() => {
          setModalOpen(false);
        }, 500);
      })
      .catch((err) => {
        // Failure: Display the error message
        setError(err.message || 'An unknown error occurred during login.');
        console.error('Login error:', err);
      })
      .then(() => {
        setLoading(false);
      });
  };

  const handleLogout = () => {
    localStorage.removeItem(TOKEN);
    setIsLoggedIn(false);
    setSuccessMessage('Logged out successfully.');
    onTokenChange(null)
  };

  const closeModal = () => {
    setModalOpen(false);
    // Clear state when closing
    setUsername('');
    setPassword('');
    setError(null);
    setLoading(false);
  }

  return (
    <div>

      {successMessage && (
        <Message error={false} className="mb-4">
          <p>{successMessage}</p>
        </Message>
      )}

      {isLoggedIn ? (
        <Button primary onClick={handleLogout} disabled={loading} style={{marginBottom: "12px"}}>
          Clear Token
        </Button>
      ) : (
        <Modal
          open={modalOpen}
          onClose={closeModal}
          trigger={
            <Button primary onClick={() => setModalOpen(true)}>
              Open Login Modal
            </Button>
          }
        >
          {/* Modal Content */}
          <Form onSubmit={handleLogin} error={error} style={{padding: "12px"}}>
            <h3 className="" style={{marginBottom: "12px"}}>Login to Beaker2</h3>
            
            {error && (
              <Message error>
                <p>{error}</p>
              </Message>
            )}

            <Input
              type="text"
              name="username"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              fluid
              label="Username"
              style={{marginBottom: "12px"}}
            />

            <Input
              type="password"
              name="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fluid
              label="Password"
              style={{marginBottom: "12px"}}
            />

            <div className="">
                <Button onClick={closeModal} disabled={loading}>
                    Cancel
                </Button>
                <Button primary type="submit" loading={loading} disabled={loading}>
                    Login
                </Button>
            </div>
          </Form>
        </Modal>
      )}

    </div>
  );
}

// export default Beaker2LoginModal


// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/Beaker2LoginButton.jsx